import {
  Icon, IconName, Tooltip, ToolTipSize, ToolTipTheme,
} from "@trussle/external-components";
import React, { FunctionComponent } from "react";

export const CalculatorTooltip: FunctionComponent<{
  body: React.ReactNode;
}> = ({ body }) => (
  <Tooltip
    position="right"
    theme={ToolTipTheme.V4}
    size={ToolTipSize.Small}
    body={body}
    className="calculator-tooltip"
    classOverrides={{ body: "calculator-tooltip-body" }}
  >
    <div className="calculator-tooltip-icon">
      <Icon name={IconName.InfoV3} />
    </div>
  </Tooltip>
);
